import { render, staticRenderFns } from "./clickBD.vue?vue&type=template&id=cd3f1c7c&scoped=true"
import script from "./clickBD.vue?vue&type=script&lang=js"
export * from "./clickBD.vue?vue&type=script&lang=js"
import style0 from "./clickBD.vue?vue&type=style&index=0&id=cd3f1c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3f1c7c",
  null
  
)

export default component.exports